/*
 * ─── ECHOES CONTENT ───
 * Weekly refresh: edit this block, push to live.
 * Each row: number, title, description, tag, url
 */
export const ECHOES_DATA = {
  weekLabel: "ECHOES · WEEK OF MAY 26",
  title: "What travels slowly.",
  subline: "",
  nextWeek: "NEXT WEEK · JUN 2",
  footLine: "Refreshed weekly. The room is small on purpose.",
  rows: [
    {
      number: "01",
      title: "Making of Laila",
      description: "The film that disappeared in three days. Found by an audience six years later. Notes from the room where it was made.",
      tag: "FROM THE FILMS",
      url: "https://www.youtube.com/c/avitiw/videos",
    },
    {
      number: "02",
      title: "Bihar to Times Square",
      description: "Humans of Bombay. Karishma Mehta. The fifteen years between film school and the first lead.",
      tag: "CONVERSATION",
      url: "https://open.spotify.com/episode/2URgTxophpEmAzkj73uTQn",
    },
    {
      number: "03",
      title: "Lights, Camera, Podcast — Ep. 3",
      description: "An hour with Rohit Khilnani on Bollywood Hungama. On waiting, on Laila Majnu, on what comes after a film disappears.",
      tag: "CONVERSATION",
      url: "https://www.youtube.com/watch?v=xwLnLAXEzII",
    },
    {
      number: "04",
      title: "The Domino's ad that became a meme",
      description: "Nineteen-year-old me, found by the internet ten years later. The work doesn't always know when it will be seen.",
      tag: "BEFORE",
      url: "https://www.youtube.com/c/avitiw/videos",
    },
    {
      number: "05",
      title: "At home with Farah and Dilip",
      description: "Litti chokha, malai chicken tikka, and old film stories. Medha drops by. The lightest hour you'll spend on YouTube this week.",
      tag: "AT HOME",
      url: "https://www.youtube.com/watch?v=ifopbUUmU5I",
    },
  ],
};
